import PropTypes from 'prop-types';
import { Button } from '@mantine/core';
import { IconArrowNarrowLeft, IconLogout } from '@tabler/icons-react';
import authApi from '@/api/services/auth';
import prepareTranslate from '@/helpers/dictionary';
import { useNavigate } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import routes from '@/routes';
import useOpenEventsCount from '@/hooks/useOpenEventsCount';
import NavbarLink from '../NavbarLink';
import styles from './style.module.css';
import { useNavbar } from '../../hooks/NavbarContext';
import Modal from '../Modal/Index';

const Navbar = ({ links = [] }) => {
  const { isExpanded, setIsExpanded } = useNavbar();
  const { data: openCount = 0 } = useOpenEventsCount();

  const enrichedLinks = links.map((link) => (
    link.to === routes.events.path ? { ...link, badge: openCount } : link
  ));
  const navigate = useNavigate();
  const [modalOpened, { open: modalOpen, close: modalClose }] = useDisclosure();
  const t = prepareTranslate();

  const toggleNavbar = () => {
    setIsExpanded((prev) => !prev);
  };

  const onLogOutClick = () => {
    modalOpen();
  };

  const handleLogOut = () => {
    authApi.logout();
    navigate(routes.login.path);
  };

  const logOutModalActions = [
    <Button
      key={'logoutButton'}
      onClick={handleLogOut}>
      {t('components.navbar.logout')}
    </Button>,
    <Button
      key='cancelButton'
      variant='outline'
      onClick={() => modalClose()}>
    {t('global.cancel')}
    </Button>,
  ];

  return (
    <>
      <nav className={`${styles.navbar} ${isExpanded ? styles.expanded : ''}`}>
        <button
          className={`${styles.expandedButton} ${isExpanded ? styles.expanded : ''}`}
          onClick={toggleNavbar}
        >
          <IconArrowNarrowLeft className={`${isExpanded ? styles.iconRotated : styles.iconDefault}`} stroke={2} size={16} />
        </button>

        <div className={styles.inner}>
          {enrichedLinks.map((link) => (
            <NavbarLink {...link} key={link.label} expanded={isExpanded} />
          ))}
          <NavbarLink
            icon={IconLogout}
            label="התנתקות"
            onClick={onLogOutClick}
            expanded={isExpanded}
          />
        </div>
      </nav>
      <Modal
        label={t('components.navbar.ensureLogout')}
        opened={modalOpened}
        close={modalClose}
        actions={logOutModalActions}
      />
    </>
  );
};

Navbar.propTypes = {
  links: PropTypes.array,
};

export default Navbar;
